import React 					from 'react';
import PropTypes 				from 'prop-types';
import BLComponent 				from '../core/_BLComponent.jsx';

import SimpleProductCard 	from '../common/_SimpleProductCard.jsx';
import {ColorWheel}			from '../common/_Icons.jsx';
import HiddenScroll			from '../common/_HiddenScroll.jsx';
import BreadCrumbs			from '../common/_BreadCrumbs.jsx';

//this.props.classes			: string of classes
/*this.props.data					: {
																link 			: (optional) string of link
															, image 			: string of image url
															, name 				: string of name
															, itemNumber 		: (optional) string of item number
															, altItemNumber 	: (optional) string of alt item number
															, condition 		: (optional) char for condition mapping 
															, sub condition 	: (optional) char for sub-condition mapping 
															, inventory 		: (optional) url of inventory listing
															, year 				: (optional) integer of year
															, qtyInSet 			: (optional) integer of qty
															, altMatchID 		: (optional) integer of matching ids
															, price 			: (optional) string of price
															, qty 				: (optional) integer of qty
														}*/

export default class PartColorListingItem extends BLComponent 
{
	constructor(props) 
	{
		super(props);

		this.state = 
			{
				colorStatus: 		0
			,	colorError:			""
			,	colorItems:			null
			,	wantedListEnabled:	( props.wantedList && props.wantedList.enabled )
			,	qtyCheckEnabled: 	( props.qtyCheckEnabled )
			,	isWanted:			( props.wantedList && props.wantedList.isWanted )
			,	wantedCnt:			( props.wantedList && props.wantedList.wantedCount ) ? props.wantedList.wantedCount : 0
			,	limitedAvailable:	false
			}

		this._callbackRegistered	= null;
	}

	static getDerivedStateFromProps( nextProps, prevState ) 
	{
		prevState.wantedListEnabled	= ( nextProps.wantedList && nextProps.wantedList.enabled );
		prevState.qtyCheckEnabled	= nextProps.qtyCheckEnabled;
		prevState.limitedAvailable	= nextProps.limitedAvailable == true ? true : false;

		return prevState;
	}

	componentDidMount() 
	{
		this.fetchPersonalizeData();
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		if ( this._callbackRegistered != null )
			blapp.personalized.unregisterCallback( this._callbackRegistered );
	}	


	componentDidUpdate( prevProps, prevState ) 
	{
		if ( ( prevState.wantedListEnabled != this.state.wantedListEnabled
				|| prevState.qtyCheckEnabled != this.state.qtyCheckEnabled
				|| prevProps.data.idItem != this.props.data.idItem
				|| prevProps.data.idColor != this.props.data.idColor )
			&& ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) )
		{
			blapp.personalized.fetchWantedPrefData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData );
		}

		if ( prevProps.overrideDrawer != this.props.overrideDrawer && prevState.colorStatus != 0 ) 
		{
			this.setState({colorStatus: 0});
		}
	}


	render() 
	{
		const 	{classes = '', overrideDrawer = false, isCatalog = false} = this.props;
		const 	{link = null, image, name, itemNumber = null, colorCnt} = this.props.data;
		const	cInfo	= blapp.color.get( this.props.data.idColorShown );

		// const isOpen = overrideDrawer ? overrideDrawer : this.state.colorStatus;

		//const breadcrumbs 			= [{link: '#', content: 'Parts'}, {link: '#', content: 'Cat'}, {link: '', content: itemNumber}];
		let {breadcrumbs = null} 	= this.props;
		const wantedListIsWanted 	= this.state.isWanted;
		const wantedListCount 		= this.state.wantedCnt;

		if (isCatalog && itemNumber) 
			breadcrumbs = [...breadcrumbs, {link: '', content: itemNumber}];

		return (
			<article className={"product-listing-item " + classes + (this.state.colorStatus > 0 ? ' part-color-listing-item--active' : '')}>
				<div className="product-listing-item__internal part-color-listing-item__internal">
					<div className="product-listing-item__image product-listing-item__image--large">
						{link ?
							<a className="link--inherit" href={link}>
								<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
							</a>
						:
							<img src={image} onError={(e) => e.target.src = `//${blapp.config.getHost( "static" )}/clone/img/no_image.png`} className="l-block"/>
						}
					</div>
					<div className="product-listing-item__info part-color-listing-item__info">
						{breadcrumbs ? 
							<BreadCrumbs classes="product-listing-item__categories" crumbs={breadcrumbs} clean={true} type={'arrow'}/> 
						: ( itemNumber ? <span>{itemNumber}</span> : null )}
						{link ? 
							<a className="link--inherit product-listing-item__name text--strong" href={link}>{name}</a>
						:
							<strong className="product-listing-item__name">{name}</strong>
						}

						{this.state.limitedAvailable && <span className="text-color--primaryRed product-listing-item__limited-available l-margin-top--xs">Almost gone</span>}
						<div className="product-listing-item__wanted product-card__wanted-list l-margin-bottom">
							<button className="l-cursor-pointer" onClick={() => this.toggleAddWantedList()}>
								<i className={"product-card__wanted-icon l-margin-right--sm " + (wantedListIsWanted ? "fas fa-heart" : "far fa-heart") + (wantedListIsWanted ? " product-card__wanted-icon--active" : "")}></i>
								{wantedListCount}
							</button>
						</div>

						{colorCnt > 1 ?
							<button className="btn btn--blank part-color-card__color-count l-margin-top--auto" onClick={() => this.toggleColors()}>
								<ColorWheel classes="l-margin-right--sm"/>{colorCnt}<i className={"l-margin-left--sm fas fa-fw " + (this.state.colorStatus ? 'fa-chevron-up' : 'fa-chevron-down')}/>
							</button>
						:
							(cInfo && <div className="l-margin-top--auto l-flex l-center"><i className="color-swatch color-swatch--small-tight color-swatch--rounded l-margin-right--sm" style={{backgroundColor: '#' + cInfo.strColorHex, borderColor: cInfo.strColorHex == 'FFFFFF' ? '#111111' : '#' + cInfo.strColorHex}}/>{cInfo.strColorName}</div>)
						}
					</div>
					<div className="part-color-listing-item__children">
						<header className="l-flex l-split l-center part-color-card__children-title">
							<h3 className=" text--small-title">{name} ({colorCnt})</h3>
							<button className="btn btn--blank l-margin-left text--title" onClick={() => this.toggleColors()}><i className="far fa-times"/></button>
						</header>
						<HiddenScroll>
							{this.renderColors()}
						</HiddenScroll>
					</div>
				</div>
			</article>
		);
	}

	renderColors()
	{
		if ( this.state.colorStatus == 1 )
		{
			return	( <div className="l-pad l-full-width text--center text-color--white">Loading ...</div> );
		}
		else if ( this.state.colorStatus == -1 )
		{
			return	( <div className="l-pad l-full-width text--center text-color--white">Error : {this.state.colorError}</div> );
		}
		else if ( this.state.colorStatus == 2 )
		{
			return	this.state.colorItems.map( ( ci, idx ) => <SimpleProductCard key={idx} item={ci}/> );
		}
	}

	fetchPersonalizeData()
	{
		if ( ( this.state.wantedListEnabled || this.state.qtyCheckEnabled ) && this.props.data.idItem )
		{
			this._callbackRegistered	= this.updatePersonalizedData;
			blapp.personalized.fetchPersonalizedData( this.props.data.idItem, this.props.data.idColor, this.updatePersonalizedData, this.state.wantedListEnabled, this.state.qtyCheckEnabled );
		}
	}	

	toggleColors()
	{

		if ( this.state.colorStatus > 0 )
		{
			this.setState( { colorStatus: 0 } );
		}
		else
		{
			if ( this.state.colorItems == null )
			{
				blapp.models.fetch(
					"_itemEx" + this.props.data.idItem
				,	{
						controller:		"catalog.BLCCatalogItem"
					,	method:			"getExtended"
					,	params:			[ this.props.data.idItem ]
					}
				).then(
					( data ) =>
					{
						let colorItems	= [];
						let	filter		= null;

						if ( this.state.colorStatus == 0 )
							return;						

						if ( !_.isEmpty( this.props.colorFilter ) )
						{
							filter	= {};
							_.forEach( this.props.colorFilter, ( c ) => { filter[ c ] = true; } );
						}

						if ( data.mapColorVerified )
						{
							_.forEach(
								data.mapColorVerified
							,	( v, idColor ) =>
								{
									idColor	= parseInt( idColor );

									if ( filter != null && !filter[ idColor ] )
										return;

									const	ci	= blapp.color.get( idColor );

									if ( ci )
									{
										let	img	= data.mapColorImgs ? data.mapColorImgs[ idColor ] : null;

										if ( img == null )
										{
											img					= _.clone( data.dmBasic.imgDefault );
											img.idColor			= idColor;
											img.bNotAvailable	= true;
										}

										colorItems.push(
											{
												id:			idColor
											,	name:		ci.strColorName
											,	image:		blapp.url2.getCatalogItemImgUrl( img, "T2" )
											,	link:		blapp.url2.getCatalogItemPageUrl( data.dmBasic, idColor )
											}
										);
									}
								}
							)

							colorItems.sort( ( l, r ) => l.name.localeCompare( r.name ) );
						}
						else
						{
							const	ci			= blapp.color.get( data.dmBasic.idColorDefault );

							if ( ci )
							{
								colorItems.push(
									{
										id:			ci.idColor
									,	name:		ci.strColorName
									,	image:		blapp.url2.getCatalogItemImgUrl( data.dmBasic.imgDefault, "T2" )
									,	link:		blapp.url2.getCatalogItemPageUrl( data.dmBasic, ci.idColor )
									}
								);								
							}
						}
						
						if ( _.isEmpty( colorItems ) )
							this.setState( { colorStatus: -1, colorError: "Color information not available." } );
						else
							this.setState( { colorStatus: 2, colorItems: colorItems } );
					}
				).catch( 
					( err ) =>
					{
						if ( this.state.colorStatus > 0 )
							this.setState( { colorStatus: -1, colorError: err } );
					}
				);


				this.setState( { colorStatus: 1 } );
			}
			else
			{
				this.setState( { colorStatus: 2 } );
			}
		}

		if ( this.props.drawerFunction ) 
		{
			this.props.drawerFunction();
		}
	}

	toggleAddWantedList = () =>
	{
		if ( this.state.wantedListEnabled )
		{
			const	srcMap 	= 	_.assign( 
									{ location: blapp.srcmap.LOCATION.GENERAL_XP, typeSrcFrom: blapp.srcmap.SRCTYPE.CATALOG_ITEM, idSrcFrom: this.props.wantedList.dmItemView.dmItem.idItem }
								,	this.props.wantedList && this.props.wantedList.srcMap ? this.props.wantedList.srcMap : {}
								);

			blapp.wanted.showAddWantedListModal
			(
				this.props.wantedList.dmItemView
			,	() => { this.fetchPersonalizeData(); }
			,	srcMap
			);
		}
	}

	updatePersonalizedData = ( data ) => 
	{
		if ( data && data.dataWantedPref )
		{
			this.setState( { isWanted: data.dataWantedPref.bIsWanted, wantedCnt: data.dataWantedPref.nWantedUserCnt } );
		}

		if ( data && data.dataRemainQty )
		{
			this.setState( { limitedAvailable: ( data.dataRemainQty.nRemainQtyIC > 0 && data.dataRemainQty.nRemainQtyIC <= 5 ) ? true : false } );
		}
	}	

	static getDataFromItemAndImg( dmItem, dmImg, idColor )
	{
		return	{
					link:		blapp.url2.getCatalogItemPageUrl( dmItem, idColor )
				,	image: 		blapp.url2.getCatalogItemImgUrl( dmImg,"T2" )
				,	name:		dmItem.strItemName
				,	itemNumber:	dmItem.strItemNoFull
				,	inventory:	dmItem.typeItem == 'S' ? '#' : null
				}
	}

	static getDataFromBLMCatalogItemWithColor( item, imgSize )
	{
		return	{
					link:			blapp.url2.getCatalogItemPageUrl(item.dmItem, item.idColor)
				,	image:			blapp.url2.getCatalogItemImgUrl( item.dmImg, imgSize )
				,	name:			item.dmItem.strItemName
				,	itemNumber:		item.dmItem.strItemNoFull
				,	inventory:		item.dmItem.typeItem == 'S' ? '#' : null
				,	idItem:			item.dmItem.idItem
				,	idColor:		item.idColor
				,	colorCnt:		item.nMatchedColorCnt
				,	idColorShown:	item.dmImg ? item.dmImg.idColor : item.idColor
				}
	}


	static getWantedListEnableInfo( dmItemView, srcMap )
	{
		return 	{
					enabled: 		true
				,	isWanted:		false
				,	wantedCount: 	0
				,	dmItemView:		dmItemView
				,	srcMap:			srcMap
				};
	}	
}

PartColorListingItem.propTypes = 
	{
		classes:			PropTypes.string
	,	data:				PropTypes.shape(
								{
									link: 		PropTypes.string
								,	image: 		PropTypes.string.isRequired
								,	name: 		PropTypes.string.isRequired
								,	itemNumber:	PropTypes.string
								,	colorCnt:	PropTypes.string
								}
							).isRequired
	,	wantedList:			PropTypes.shape(
								{
									enabled:		PropTypes.bool
								,	isWanted:		PropTypes.bool
								,	wantedCount:	PropTypes.number
								,	dmItemView:		PropTypes.object
								,	srcMap:			PropTypes.object
								}
							)
	,	qtyCheckEnabled:	PropTypes.bool
	,	limitedAvailable:	PropTypes.bool
	,	overrideDrawer:		PropTypes.bool
	,	drawerFunction:		PropTypes.func
}